import clsx from 'clsx'
import {FC, useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'
import {HubConnectionBuilder} from '@microsoft/signalr'
import {getToken} from '../../../../app/modules/auth/helpers'
import {useLocalStorage} from '../../../../app/utils'
import {getListSellingNotification} from '../../../../app/modules/auth/apis'
import { SnackbarCustom } from '../../../../app/components'
import { useDispatch } from 'react-redux'
import * as component from '../../../../app/components/redux/componentRedux'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  const [showNotiIcon, setShowNotiIcon] = useState(false)
  const [userRoot] = useLocalStorage<any>('persist:root', [])
  const {config} = useLayout()
  const dispatch = useDispatch()
  
  useEffect(() => {
    const connect = new HubConnectionBuilder()
      .withUrl('https://devapi1.tokiomarine.com.vn/notification/hub/notificationhub', {
        accessTokenFactory: () => {
          return getToken()
        },
      })
      .withAutomaticReconnect()
      .build()

    if (connect) {
      connect
        .start()
        .then(() => {
          connect.on('NotificationState', (message) => {
            if(message) {
              if(!showNotiIcon) setShowNotiIcon(true)
              dispatch(component.actions.showSnackbar({
                show: true,
                message: message.content,
                contractId: message.contractId,
                productCode: message.extrafieldId3
              }))

            }
          })
        })
        .catch(() => {
          return
        })
    }
    getListSellingNotification(userRoot?.userId?.replaceAll('"', ''))
      .then((res: any) => {
        if (res && !res.isError) {
          let checkNoti = res.data.items.filter((o: any) => !o.isRead)
          if (checkNoti.length > 0) setShowNotiIcon(true)
        }
      })
      .catch((error) => {
        return
      })
  }, [])

  return (
    <>
      <div className='d-flex align-items-stretch flex-shrink-0'>
        {/* Search */}
        {/* <div className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}>
        <Search />
      </div> */}
        {/* Activities */}
        {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        <div
          className={clsx('btn btn-icon btn-active-light-primary', toolbarButtonHeightClass)}
          id='kt_activities_toggle'
        >
          <KTSVG
            path='/media/icons/duotune/general/gen032.svg'
            className={toolbarButtonIconSizeClass}
          />
        </div>
      </div> */}
        {/* Quick links */}
        {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        <div
          className={clsx('btn btn-icon btn-active-light-primary', toolbarButtonHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG
            path='/media/icons/duotune/general/gen025.svg'
            className={toolbarButtonIconSizeClass}
          />
        </div>
        <QuickLinks />
      </div> */}

        {/* CHAT */}
        {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        <div
          className={clsx(
            'btn btn-icon btn-active-light-primary position-relative',
            toolbarButtonHeightClass
          )}
          id='kt_drawer_chat_toggle'
        >
          <KTSVG
            path='/media/icons/duotune/communication/com012.svg'
            className={toolbarButtonIconSizeClass}
          />

          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink'></span>
        </div>
      </div> */}

        {/* NOTIFICATIONS */}
        <div
          className={clsx('d-flex align-items-center position-relative', toolbarButtonMarginClass)}
        >
          {showNotiIcon && <div className='notification-alert-dot'></div>}
          <div
            className={clsx(
              'btn btn-icon btn-active-light-primary position-relative',
              toolbarButtonHeightClass
            )}
            id='btn-show-noti'
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <KTSVG
              path='/media/icons/duotune/general/gen007.svg'
              className={toolbarButtonIconSizeClass}
            />
          </div>
          <HeaderNotificationsMenu />
        </div>

        {/* begin::User */}
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <img src={toAbsoluteUrl('/media/avatars/150-2.jpg')} alt='metronic' />
          </div>
          <HeaderUserMenu />
        </div>
        {/* end::User */}

        {/* begin::Aside Toggler */}
        {config.header.left === 'menu' && (
          <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
            <div
              className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
              id='kt_header_menu_mobile_toggle'
            >
              <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
            </div>
          </div>
        )}
      </div>
      <SnackbarCustom />
    </>
  )
}

export {Topbar}
